import { FormulationTableProperties } from 'types/Products';

export const getUniquePhases = (formulations: FormulationTableProperties[]) => {
  return formulations
    ?.map(formulation => formulation.properties?.phase)
    .filter((value, index, self) => self.indexOf(value) === index)
    .filter((value): value is string => value !== undefined);
};

export const getNumberFromLetter = (letter: string) => {
  const charCodeA = 'A'.charCodeAt(0);
  const charCodeLetter = letter.toUpperCase().charCodeAt(0);

  return charCodeLetter - charCodeA;
};

export const getMissingLetters = (arr: string[]): string[] => {
  const missingLetters = Array.from({ length: 26 }, (_, index) =>
    String.fromCharCode('A'.charCodeAt(0) + index)
  ).filter(letter => !arr.includes(letter) && letter < arr[arr.length - 1]);

  return missingLetters;
};
